import React from "react";
import { Container, Text, Title, Paper, Button } from "@mantine/core";
import { Link } from "wouter";

const PaymentCancelled = () => (
  <Container size="xs" ta="center">
    <Paper mt="xl" p="lg" withBorder>
      <Title mb="xl" order={2}>
        Payment Cancelled
      </Title>
      <Text>Your payment was cancelled, no money was deducted.</Text>
      <Text mt="xl">
        Please get in touch with{" "}
        <a href="mailto:support@autarky.dev">support@autarky.dev</a> if you have
        any trouble with the payment!
      </Text>
      <Button mt="xl" component={Link} to="/settings/tenant">
        Back to Profile
      </Button>
    </Paper>
  </Container>
);

export default PaymentCancelled;
